var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { exportForPrinting } from '../../../Editor/CanvasHelpers';
import { saveTemplate } from '../../../Actions/Rutab/DecalEditor.action';
import { translate } from '../../../Services/translation';
const SaveEditorTemplate = ({ fabricCanvas, }) => {
    const dispatch = useDispatch();
    const store = useStore();
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [templateName, setTemplateName] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const handleSaveTemplate = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!templateName.trim())
            return;
        setIsSaving(true);
        const state = store.getState();
        const uploadedImages = state.decalEditorAPI.uploadedImages;
        if (uploadedImages.length > 0) {
            alert('Du kan inte ladda upp bilder till en mall');
            setIsSaving(false);
            return;
        }
        if (fabricCanvas.getObjects().length === 0) {
            alert('Du kan inte spara en tom mall');
            setIsSaving(false);
            return;
        }
        const canvasSize = state.decalEditor.canvasSize;
        const canvasType = state.decalEditor.canvasType;
        const selectedForm = state.decalEditor.selectedForm;
        const holePlacement = state.decalEditor.holePlacement;
        const exportObject = exportForPrinting(fabricCanvas, canvasSize, canvasType, selectedForm, holePlacement, uploadedImages);
        const imgData = fabricCanvas.toDataURL({
            format: 'png',
            multiplier: 1,
            quality: 1,
        });
        exportObject.imgPreview = imgData;
        try {
            dispatch(saveTemplate({
                template: exportObject,
                templateName,
                imgPreview: '',
                templateId: null,
            }));
            setShowTemplateModal(false);
            setTemplateName('');
        }
        catch (error) {
            console.error('Failed to save template:', error);
        }
        finally {
            setIsSaving(false);
        }
    });
    const handleCancel = () => {
        setShowTemplateModal(false);
        setTemplateName('');
    };
    return (_jsxs(_Fragment, { children: [showTemplateModal && (_jsx("div", { className: "modal-overlay", onClick: handleCancel, style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1001,
                }, children: _jsxs("div", { className: "modal-content", onClick: (e) => e.stopPropagation(), style: {
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        width: '400px',
                        maxWidth: '90%',
                    }, children: [_jsxs("div", { style: { marginBottom: '20px' }, children: [_jsx("h3", { style: { margin: '0 0 20px 0', fontSize: '20px' }, children: "Spara som mall" }), _jsxs("div", { style: { marginBottom: '20px' }, children: [_jsx("label", { htmlFor: "templateName", style: {
                                                display: 'block',
                                                marginBottom: '8px',
                                                fontWeight: 500,
                                            }, children: "Mallens namn" }), _jsx("input", { id: "templateName", type: "text", value: templateName, onChange: (e) => setTemplateName(e.target.value), placeholder: "Ange ett namn f\u00F6r mallen", style: {
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                fontSize: '16px',
                                            }, autoFocus: true })] })] }), _jsxs("div", { style: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '10px',
                            }, children: [_jsx("button", { onClick: handleCancel, style: {
                                        padding: '10px 20px',
                                        background: '#f1f1f1',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                    }, children: "Avbryt" }), _jsx("button", { onClick: handleSaveTemplate, disabled: !templateName.trim() || isSaving, style: {
                                        padding: '10px 20px',
                                        background: templateName.trim() && !isSaving ? '#0066cc' : '#cccccc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: templateName.trim() && !isSaving
                                            ? 'pointer'
                                            : 'not-allowed',
                                        fontSize: '16px',
                                    }, children: isSaving ? 'Sparar...' : 'Spara' })] })] }) })), _jsxs("button", { title: translate('decal.toolbar.saveastemplate'), className: "toolbar-button", onClick: () => setShowTemplateModal(true), style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: '#333',
                    height: '40px',
                }, children: [_jsxs("svg", { width: "34", height: "34", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "11.9946", cy: "11.9951", r: "11.9946", fill: "white" }), _jsx("circle", { cx: "11.9946", cy: "11.9951", r: "11.4946", stroke: "black", strokeOpacity: "0.2" }), _jsx("mask", { id: "mask0_1823_481", maskUnits: "userSpaceOnUse", x: "6", y: "5", width: "13", height: "13", children: _jsx("rect", { x: "6.125", y: "5.61475", width: "12.2498", height: "12.2498", fill: "#D9D9D9" }) }), _jsx("g", { mask: "url(#mask0_1823_481)", children: _jsx("path", { d: "M16.8436 9.18762V15.3125C16.8436 15.5932 16.7436 15.8336 16.5437 16.0335C16.3438 16.2334 16.1035 16.3333 15.8228 16.3333H8.67706C8.39634 16.3333 8.15602 16.2334 7.95611 16.0335C7.7562 15.8336 7.65625 15.5932 7.65625 15.3125V8.16681C7.65625 7.88609 7.7562 7.64577 7.95611 7.44586C8.15602 7.24595 8.39634 7.146 8.67706 7.146H14.8019L16.8436 9.18762ZM15.8228 9.62147L14.3681 8.16681H8.67706V15.3125H15.8228V9.62147ZM12.2499 14.8021C12.6753 14.8021 13.0368 14.6532 13.3345 14.3555C13.6323 14.0578 13.7811 13.6962 13.7811 13.2709C13.7811 12.8455 13.6323 12.484 13.3345 12.1863C13.0368 11.8885 12.6753 11.7397 12.2499 11.7397C11.8246 11.7397 11.463 11.8885 11.1653 12.1863C10.8676 12.484 10.7187 12.8455 10.7187 13.2709C10.7187 13.6962 10.8676 14.0578 11.1653 14.3555C11.463 14.6532 11.8246 14.8021 12.2499 14.8021ZM9.18747 10.7188H13.7811V8.67722H9.18747V10.7188Z", fill: "#677999" }) })] }), _jsx("span", { children: translate('decal.toolbar.saveastemplate') })] })] }));
};
export default memo(SaveEditorTemplate);
